import React from 'react'

// Small indigo star avatar shown beside assistant messages.
export default function BotAvatar() {
  return (
    <div style={{ width: 24, height: 24, borderRadius: 6, background: '#5B68C3', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      <svg width="14" height="14" viewBox="5 7 14 14" fill="none">
        <path d="M12.6563 7.4375L14.5313 11.4687L18.5625 13.3437C18.8125 13.4687 19 13.7187 19 14C19 14.3125 18.8125 14.5625 18.5625 14.6875L14.5313 16.5625L12.6563 20.5937C12.5313 20.8437 12.2813 21 12 21C11.6875 21 11.4375 20.8437 11.3125 20.5937L9.4375 16.5625L5.40625 14.6875C5.15625 14.5625 5 14.3125 5 14C5 13.7187 5.15625 13.4687 5.40625 13.3437L9.4375 11.4687L11.3125 7.4375C11.4375 7.1875 11.6875 7 12 7C12.2813 7 12.5313 7.1875 12.6563 7.4375Z" fill="white"/>
      </svg>
    </div>
  )
}
